import React, { useEffect, useState } from 'react';
import Button from '@amzn/meridian/button';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import Select, { SelectOption } from '@amzn/meridian/select';

const CREATE_AB_TEST_HEADER = 'Create A/B Test';
const CREATE_AB_TEST_SELECT_NODE_LABEL = 'Select the last node that is part of the control group:';

export const CreateAbTest = ({ abTestEndOptions, onAccept, onCancel }) => {
  const [selectedNode, setSelectedNode] = useState(null);

  useEffect(() => {
    if (abTestEndOptions && abTestEndOptions.length > 0) {
      setSelectedNode(abTestEndOptions[abTestEndOptions.length - 1]);
    } else {
      setSelectedNode(null);
    }
  }, [abTestEndOptions]);

  return (
    <Modal open title={CREATE_AB_TEST_HEADER} width="600px">
      <div>
        <Select
          name="abTestEndSelection"
          value={selectedNode}
          label={CREATE_AB_TEST_SELECT_NODE_LABEL}
          onChange={setSelectedNode}
        >
          {abTestEndOptions.map(endOption => (
            <SelectOption value={endOption.id} key={endOption.id} label={endOption.type} />
          ))}
        </Select>
      </div>
      <ModalFooter>
        <Row alignmentHorizontal="right" widths="fit">
          <Button type="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="primary" onClick={() => onAccept(selectedNode)}>
            Accept
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};
